export const Colors = {
    primary: "#837493",
    // secondary: "#E8C547",
    secondary: "#00B4D8",
    terciary: '#29AABC'
}